import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/orderlist/orderlistyunyang.png';
import _imports_1 from '@assets/images/orderlist/orderlistzhongchou.png';
import _imports_2 from '@assets/images/orderlist/orderlistshop.png';
import _imports_3 from '@assets/images/orderlist/ziyinglogo.png';
const _withScopeId = n => (_pushScopeId("data-v-32f3b238"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "leftbox"
};
const _hoisted_2 = {
  key: 0,
  class: "icon",
  src: _imports_0
};
const _hoisted_3 = {
  key: 1,
  class: "icon",
  src: _imports_1
};
const _hoisted_4 = {
  class: "name"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "righticon",
  "aria-hidden": "true"
}, null, -1));
const _hoisted_6 = {
  class: /*#__PURE__*/_normalizeClass(['status'])
};
const _hoisted_7 = {
  class: "leftbox"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_2
}, null, -1));
const _hoisted_9 = {
  class: "name"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "righticon",
  "aria-hidden": "true"
}, null, -1));
const _hoisted_11 = {
  class: "status"
};
const _hoisted_12 = {
  class: "leftbox"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_2
}, null, -1));
const _hoisted_14 = {
  class: "name"
};
const _hoisted_15 = {
  key: 0,
  class: "ziyinglogo",
  src: _imports_3
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "righticon",
  "aria-hidden": "true"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.item.order_type != 4 && $props.item.business_code !== 4 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "shop",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.jumpProList(), ["stop"]))
  }, [_createElementVNode("div", _hoisted_1, [$props.item.order_type == 1 ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : (_openBlock(), _createElementBlock("img", _hoisted_3)), _createElementVNode("div", _hoisted_4, _toDisplayString($props.item.order_type == 1 ? "云养计划" : $props.item.order_type == 3 ? "课程" : "众筹"), 1), _hoisted_5]), _createElementVNode("div", _hoisted_6, _toDisplayString($props.item.status_data ? $props.item.status_data.status_name : $props.item.status_name || ''), 1)])) : $props.nav == 200 && $props.item.business_code == 4 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "shop",
    onClick: _cache[1] || (_cache[1] = _withModifiers($event => $options.jumpShop($props.item.title_info.relation_id), ["stop"]))
  }, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, _toDisplayString($props.item.title_info.title), 1), _hoisted_10]), _createElementVNode("div", _hoisted_11, _toDisplayString($props.item.status_name || ''), 1)])) : $props.item.mall && $props.item.mall.shop_info ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "shop",
    onClick: _cache[2] || (_cache[2] = _withModifiers($event => $options.jumpShop($props.item.mall.shop_info.shop_id), ["stop"]))
  }, [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, _toDisplayString($props.item.mall.shop_info.name), 1), $props.item.mall.shop_info.official != '0' ? (_openBlock(), _createElementBlock("img", _hoisted_15)) : _createCommentVNode("", true), _hoisted_16]), $props.item.status_data ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(['status', {
      pay: $props.item.status_data.status == 101
    }])
  }, _toDisplayString($props.item.status_data ? $props.item.status_data.status_name : $props.item.status_name || ''), 3)) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
}